<template>
    <div>
        <b-navbar toggleable="lg" type="dark"  class="navbar-modify">
            <div class="container-fluid">
                <b-navbar-brand to="/">
                  <img :src="logo" class="logo"/>
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                 <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item class="nav-link" to="/">{{ $t('nav1') }}</b-nav-item>
                        <b-nav-item class="nav-link" to="/donnees">{{ $t('nav2') }}</b-nav-item>
                        <b-nav-item class="nav-link" to="/methodologie">{{ $t('nav3') }}</b-nav-item>
                        <b-nav-item class="nav-link" to="/rapport">{{ $t('nav4') }}</b-nav-item>
                        <b-nav-item class="nav-link" to="/histoire">{{ $t('nav5') }}</b-nav-item>
                        <b-nav-item class="nav-link" to="/ressources">{{ $t('nav6') }}</b-nav-item>
                        <b-nav-item class="nav-link" to="/a-propos">{{ $t('nav7') }}</b-nav-item>
                        <a class="nav-link sm:mt-20 media-sociaux-mobile" href="https://twitter.com/stopmtl" target="_blank"><font-awesome-icon :icon="['fab', 'twitter-square']" size="2x" class="nav-socials mt-1">  Twitter </font-awesome-icon></a>
                        <a class="nav-link media-sociaux-mobile" href="https://www.facebook.com/stopmtl" target="_blank"><font-awesome-icon :icon="['fab', 'facebook-square']" size="2x" class="nav-socials mt-1">  Facebook </font-awesome-icon></a>
                        <a class="nav-link media-sociaux-mobile" href="https://www.instagram.com/stopmtl" target="_blank"><font-awesome-icon :icon="['fab', 'instagram-square']" size="2x" class="nav-socials mt-1">  Instagram </font-awesome-icon></a>
                        <b-nav-item class="nav-link language" v-for="language in languages" v-if="language!= $i18n.locale" @click="changeLocale(language)">{{language}}</b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </div>  
        </b-navbar>
    </div>
</template>
<script>
import logo from '../assets/images/StopMTLca_Logo2.png';
import {i18n} from '../plugins/i18n';
export default {
   data: function () {
        return {
          languages:['en', 'fr'],
          logo
        }
   },
  methods: {    
    changeLocale(locale) {
      i18n.locale= locale;    
      }
    },
    mounted() {
        let local=navigator.language || navigator.userLanguage;
         
         if(local=='en' || local=='en-US' ){
            i18n.locale='en';
         }
    },
}
</script>
<style scoped>
    .navbar-modify{
    background-color:black;
    font-family: "Web-Geogrotesque";
    padding: 18px !important;
    height: 70px;
    display: flex;
    justify-content: space-between;
    }
    .logo{
        height:60px;
    }
    .nav-link{
        color: white !important;
        font-family: 'Raleway', sans-serif;
        font-size:15px;
    }
    .language>a{
      color:#6B3FE6 !important;
    }
    @media (max-width: 991.98px) { 
    .navbar-nav{
          background-color: black;
          padding:20px;
      }
      .navbar-modify{
         height: 150px;
      }

    }
</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue